{
  "open": "Chat öffnen",
  "unread_one": "{count} ungelesene Nachricht",
  "unread_other": "{count} ungelesene Nachrichten",
  "close": "Schließen"
}
